import { Constraints } from "..";
import User from "./user";

class RemoteUser<T> extends User<T> {

  produce(offer: any, constraints: Constraints, streamName: string) {
    const stream = this.initStream(streamName)
    return stream.handleProduce(offer, constraints)
  }

  stopProduce(streamName: string) {
    this.closeStream(streamName)
  }
}

export default RemoteUser